var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremimumUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.161,
    y1: 1.322,
    x2: 1.339,
    y2: -0.612,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd47b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ff778e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b97aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_70106",
    "data-name": "Raggruppa 70106",
    transform: "translate(-419 -351.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_37366",
    "data-name": "Tracciato 37366",
    transform: "translate(419 351.297)",
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 17.5 C 4.313079833984375 17.5 0.5 13.68692016601562 0.5 9 C 0.5 4.313079833984375 4.313079833984375 0.5 9 0.5 C 13.68692016601562 0.5 17.5 4.313079833984375 17.5 9 C 17.5 13.68692016601562 13.68692016601562 17.5 9 17.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 1 C 4.588789939880371 1 1 4.588789939880371 1 9 C 1 13.41121006011963 4.588789939880371 17 9 17 C 13.41121006011963 17 17 13.41121006011963 17 9 C 17 4.588789939880371 13.41121006011963 1 9 1 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_70078",
    "data-name": "Raggruppa 70078",
    transform: "translate(423.935 357.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36337",
    "data-name": "Tracciato 36337",
    d: "M3.9,4.295q-1.662,0-3.323,0C.5,4.3.471,4.28.46,4.2.385,3.694.3,3.185.226,2.676.152,2.2.081,1.727.006,1.252A.267.267,0,0,1,.115.961.259.259,0,0,1,.431.987q.7.524,1.4,1.05a.367.367,0,0,0,.6-.1q.59-.884,1.18-1.767A.33.33,0,0,1,4.1.073.45.45,0,0,1,4.2.184q.595.89,1.189,1.78a.362.362,0,0,0,.357.178.386.386,0,0,0,.2-.089l1.39-1.041A.38.38,0,0,1,7.49.924a.256.256,0,0,1,.3.292c-.07.467-.144.933-.216,1.4q-.119.768-.235,1.536c-.021.143-.018.143-.165.143H3.9",
    transform: "translate(0 0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36338",
    "data-name": "Tracciato 36338",
    d: "M25.167,224.3q1.661,0,3.323,0c.071,0,.1.014.1.092-.006.216,0,.432,0,.648a.366.366,0,0,1-.4.4H22.132a.365.365,0,0,1-.4-.4c0-.219,0-.438,0-.657,0-.071.024-.083.088-.083q1.673,0,3.347,0",
    transform: "translate(-21.261 -219.435)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremimumUser);
export default __webpack_public_path__ + "static/media/premimumUser.25b7e9d5666df569c34d4ad288defb9b.svg";
export { ForwardRef as ReactComponent };